import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/unified-google-certificates/appEnv';

export default appStarterFactory(appEnv);
